export enum EMAbbreviateCardStatus {
  success = 'success',
  failed = 'failed',
  mismatch = 'mismatch',
  hasUnmatch = 'hasUnmatch'
}
